import { data } from '../../svg/PersonCheck/data';
import { makeIcon } from '../makeIcon';

export const PersonCheck = makeIcon(data, 'person_check', 'PersonCheck');

export default PersonCheck;
